import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";
import { primaryColor, primaryColorHover, bodyColor } from "../../../../config/constants";
import { inputCheckboxIndex } from "../../../../config/zIndex";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;

// Styles
export const PrescriptionDiv = styled.div`
  margin: 5px auto;
  width: 100%;
  max-width: 860px;
  height: 40px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  position: relative;
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    background-color: transparent;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const ProtocolCardDiv = styled.div`
  width: ${({ isClinicOrHome, isARSection }) => (isClinicOrHome ? "335px" : isARSection ? "295px" : "385px")};
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 100%;
    position: relative;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const VideoButton = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ProtocolImgAndNameDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
`;
export const ProtocolImgDiv = styled.div`
  margin-right: 15px;
  width: 80px;
  height: 40px;
  position: relative;
`;
export const ProtocolImg = styled.img`
  width: 80px;
  height: 100%;
`;
export const MinutesAdherenceDiv = styled.div`
  width: 45px;
  height: 100%;
  background-color: #fff;
  border-radius: 100px 0 0 100px;
  box-shadow: -15px 0px 20px -5px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  right: -15px;
`;
export const MinutesAdherenceText = styled.p`
  font-size: 12px;
  color: #000;
  font-weight: 600;
`;

export const VideoButtonImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const InfoImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;
export const ShowPrescriptionsButton = styled.button`
  padding: 0 5px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  position: absolute;
  right: 0;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
  }
`;
export const ArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const PrescriptionDaysDiv = styled.div`
  width: 230px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
  @media (max-width: 910px) {
    margin: 2px 0;
    height: 54px;
    width: 100%;
    max-width: 272px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    display: ${({ show }) => (show ? "flex" : "none")};
    border-radius: 5px;
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const FlexDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    height: ${({ height910 }) => height910 && height910};
    align-items: center;
    justify-content: flex-end;
  }
`;
export const SelectAllButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const SelectAllImg = styled.img`
  width: 24px;
  height: 24px;
`;
export const DayText = styled.label`
  font-size: 14px;
  color: #808080;
  display: none;
  @media (max-width: 910px) {
    margin-bottom: 7px;
    display: flex;
    font-size: 12px;
  }
`;
export const InputCheckboxDiv = styled.div`
  width: 23px;
  height: 23px;
  position: relative;
`;
export const InputCheckbox = styled.input`
  width: 23px;
  height: 23px;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const VerifyCheckboxImg = styled.img`
  width: 23px;
  height: 23px;
  position: absolute;
`;
export const CheckboxDiv = styled.div`
  width: 23px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background: ${({ background }) => background && background};
  position: relative;
`;
export const CheckboxOrderText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ExtraInfoDiv = styled.div`
  margin-left: 15px;
  padding-left: 15px;
  width: ${({ isClinicOrHome }) => (isClinicOrHome ? "280px" : "230px")};
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
  border-left: 1px solid #ccc;
  @media (max-width: 910px) {
    margin-left: 0;
    padding: 5px 0 0;
    width: 100%;
    max-width: 272px;
    height: 66px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    border-radius: 5px;
    display: ${({ show }) => (show ? "flex" : "none")};
    align-items: flex-start;
    justify-content: space-around;
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const ExtraInfoText = styled.p`
  font-size: 14px;
  color: #808080;
  display: none;
  @media (max-width: 910px) {
    margin-bottom: 7px;
    display: flex;
    font-size: 12px;
  }
`;
export const DurationSelect = styled.select`
  padding-left: 15px;
  width: 100%;
  height: 30px;
  font-size: 14px;
  color: #000;
  border: 1px solid ${bodyColor};
  border-radius: 5px;
  appearance: none;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ReportsSectionDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 2px dashed #ccc;
`;
export const SessionsDiv = styled.div`
  padding-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 910px) {
    padding-left: 15px;
  }
`;
export const ReportsLink = styled(Link)`
  width: 35px;
  height: 35px;
  background-color: ${({ sessions }) => (sessions > 0 ? primaryColor : "#808080")};
  border-radius: 5px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 30px;
    height: 30px;
  }
`;
export const ReportsImg = styled.img`
  width: 70%;
  height: 70%;
`;
export const SessionsNumber = styled.p`
  margin-left: 18px;
  font-size: 14px;
  color: #ccc;
  @media (max-width: 910px) {
    margin-left: 10px;
  }
`;
export const SupportDiv = styled.div`
  margin: 0 15px 0 5px;
  width: 70px;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const SupportText = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${({ protocolWithSupport }) => (protocolWithSupport ? "#eb5823" : "#ccc")};
`;
export const PlatformsDiv = styled.div`
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  right: -120px;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const PlatformsAlignerDiv = styled.div`
  width: ${({ width }) => width && width};
  height: 40px;
  opacity: ${({ isSomeImg }) => (isSomeImg ? 1 : 0)};
`;
export const PlatformsImg = styled.img`
  width: 100%;
  height: 100%;
`;
export const ProtocolControlsDiv = styled.div`
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ProtocolControlsButton = styled.button`
  width: 30px;
  height: 30px;
  border: ${({ border }) => border && border};
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProtocolControlsImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const ARIncompatibilityImg = styled.img`
  width: 24px;
  height: 22px;
  position: absolute;
  left: -10px;
  bottom: 2px;
`;
